export type Volume = {
  number: string
  title: string
  /** "Sessions 01–15 · foundations" */
  range: string
  promise: string
  contents: string[]
  /** Badge colour for the volume number */
  badge: string
  flag?: string
}

/** The six volumes, in the order the season is coached. */
export const volumes: Volume[] = [
  {
    number: '01',
    title: 'Set Up the Squad',
    range: 'Sessions 01–15 · foundations',
    promise:
      'Grip, stance, catching, throwing, the first drive and the first bowling action, with the whole squad moving from night one.',
    badge: 'bg-grass-deep text-white',
    flag: 'Start here',
    contents: [
      'First night: names, groups and the No-Queue rotation in 60 minutes',
      'The Bat-Ball-Job Rule and the Station Triangle',
      'From underarm to overarm: the first bowling action',
      'Running between the wickets: call, run, slide the bat',
      'The Five-Minute Squad Split: three groups that rotate without arguments',
    ],
  },
  {
    number: '02',
    title: 'Bat Without the Queue',
    range: 'Sessions 16–30 · batting',
    promise:
      'Defence, drives, back-foot shots and playing spin, with every batter hitting more balls in the same hour.',
    badge: 'bg-sky-deep text-white',
    contents: [
      'The Hard-Ball Confidence Ladder: soft ball to hard ball in five steps',
      'The 3-Feed Batting Rotation: batter, feeder, collector',
      'The off drive, the on drive and the sweep against spin',
      'Building an innings past twenty balls',
    ],
  },
  {
    number: '03',
    title: 'Bowl Line and Length',
    range: 'Sessions 31–45 · bowling',
    promise:
      'Grip, action, run-up and length, then spin and change of pace, with every ball aimed at a target.',
    badge: 'bg-willow text-willow-ink',
    contents: [
      'The Action Check Loop: gather, load, release, follow through',
      'The Length Map: four target zones on the pitch',
      'Off-spin and leg-spin basics',
      'No more no-balls or wides, and full spells within workload limits',
    ],
  },
  {
    number: '04',
    title: 'Field Like a Team',
    range: 'Sessions 46–60 · fielding & keeping',
    promise:
      'Catching, ground fielding, throwing, run-outs and wicketkeeping. Fielding as a game, not a punishment.',
    badge: 'bg-grass-deep text-white',
    contents: [
      'The Catch Ladder: from close catches to boundary catches',
      'The Backing-Up Web: where every fielder goes on every throw',
      'Direct hits for run-outs',
      'Keeping to spin and keeping to pace',
    ],
  },
  {
    number: '05',
    title: 'Play the Match Before Match Day',
    range: 'Sessions 61–75 · match sense',
    promise:
      'Scenarios, captaincy, laws and match simulations, so juniors make better decisions under pressure.',
    badge: 'bg-sky-deep text-white',
    contents: [
      'The Scenario Card System: runs, balls, wickets',
      'The Rotating Captain: every player leads a game',
      'Laws for juniors: wides, no-balls and LBW',
      'Last-over finishes and a squad match where everyone bats, bowls and fields',
    ],
  },
  {
    number: '06',
    title: 'Finish the Season Strong',
    range: 'Sessions 76–90 · late season & indoor',
    promise:
      'Refreshers, rain-ready nights, low turnouts, an end-of-season festival and a plan for the off-season.',
    badge: 'bg-willow text-willow-ink',
    contents: [
      'The Indoor Space Planner: what fits in a hall, a room or a clubhouse',
      'Indoor nets: one net, twelve players, no one waiting',
      'End-of-season festival: a mini-tournament for everyone',
      'The Three-Question Season Review',
    ],
  },
]
